"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditedImage = void 0;
var React = __importStar(require("react"));
var cropro_1 = require("cropro");
function useEditedImage(sourceImage, cropAreaState) {
    var _a = React.useState(), editedImageSrc = _a[0], setEditedImageSrc = _a[1];
    React.useEffect(function () {
        if (!sourceImage) {
            if (editedImageSrc) {
                setEditedImageSrc(undefined);
            }
            return;
        }
        if (cropAreaState) {
            var cropArea = new cropro_1.CropArea(sourceImage);
            cropArea.renderAtNaturalSize = true;
            cropArea.addRenderEventListener(function (imgURL) { return setEditedImageSrc(imgURL); });
            cropArea.renderState(cropAreaState);
        }
        else {
            setEditedImageSrc(undefined);
        }
    }, [sourceImage, cropAreaState]);
    return editedImageSrc;
}
exports.useEditedImage = useEditedImage;
